import PropTypes from 'prop-types';

const liveMathsClassPropType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    totalCorrect: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    topScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    accuracy: PropTypes.string,
    questionsPerMinute: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
});

const liveMathsLevelPropType = PropTypes.shape({
    level: PropTypes.string,
    classes: PropTypes.arrayOf(liveMathsClassPropType)
});

export { liveMathsClassPropType, liveMathsLevelPropType };



// WEBPACK FOOTER //
// ./containers/live-maths/all-classes/all-classes-prop-types.js